/**
 * Mengunduh file dari objek Blob atau File.
 * @param {Blob|File} blob - Data blob yang ingin diunduh.
 * @param {string} filename - Nama file saat diunduh.
 */
// eslint-disable-next-line import/prefer-default-export
export function downloadFileFromBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()

  // Cleanup setelah 1 siklus event loop
  setTimeout(() => {
    URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }, 0)
}
